import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a0218e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Gallery view-default" }
const _hoisted_2 = { class: "Gallery__Background" }
const _hoisted_3 = { class: "Gallery__Inner view-default__inner" }
const _hoisted_4 = { class: "Header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Slider" }, null, -1))
const _hoisted_6 = {
  class: "DragHint DragHint__Hidden rounded-full",
  ref: "dragHintRef"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "DragHint__Background" }, null, -1))
const _hoisted_8 = { class: "DragHint__Foreground" }
const _hoisted_9 = { class: "DragHint__Foreground__Inner" }
const _hoisted_10 = { class: "DragHint__Label small-caps" }
const _hoisted_11 = { class: "Footer" }

export function render(_ctx: any,_cache: any) {
  const _component_inset_border = _resolveComponent("inset-border")!
  const _component_heading = _resolveComponent("heading")!
  const _component_CustomCursor = _resolveComponent("CustomCursor")!
  const _component_MiniMap = _resolveComponent("MiniMap")!
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_inset_border)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_heading, {
          tag: "h1",
          class: "Title",
          ref: "titleRef"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("gallery.title")), 1)
          ]),
          _: 1
        }, 512),
        _createElementVNode("h2", {
          class: "Subtitle small-caps",
          ref: "subtitleRef"
        }, _toDisplayString(_ctx.$t("gallery.subtitle")), 513)
      ]),
      _hoisted_5,
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("gallery.drag_hint")), 1)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showDragHint]
      ]),
      _createVNode(_component_CustomCursor, { show: _ctx.showCustomCursor }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("museum.main_painting_cursor")), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_MiniMap, {
          data: _ctx.povDatas,
          ref: "minimapRef",
          showCoords: _ctx.isDesktop
        }, {
          default: _withCtx(() => [
            (_ctx.isDesktop)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("gallery.map_hint")), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data", "showCoords"]),
        (!_ctx.isDesktop)
          ? (_openBlock(), _createBlock(_component_ui_btn, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPhoto(_ctx.povDatas)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("gallery.cta_label")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}